<template>
  <v-card>
    <template v-if="loadingItemsWithNoExistingData">
      <v-layout>
        <v-progress-circular size="50" color="info" class="mx-auto" indeterminate />
      </v-layout>
    </template>
    <template v-else>
      <StaticContentItemTile v-for="(staticContentItem, i) in items.data" :key="`item-tile-${staticContentItem.Id}`" :value="staticContentItem" :isFirst="isFirst(i)" :isLast="isLast(i)" :isEdit="isEdit" :tenant-name="tenantName" />
    </template>
  </v-card>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const landingPageStaticContent = createNamespacedHelpers('landingPageStaticContent')

  import StaticContentItemTile from '@/components/LandingPageStaticContent/StaticContentItemTile'

  export default {
    components: {
      StaticContentItemTile,
    },
    props: {
      isEdit: {
        type: Boolean,
        default: false,
      },
      tenantName: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...landingPageStaticContent.mapState(['items']),
      loadingItemsWithNoExistingData() {
        return this.items.isLoading && this.items.data.length == 0
      },
    },
    methods: {
      isFirst(index) {
        return index == 0
      },
      isLast(index) {
        return index == (this.items.data.length - 1)
      },
    },
  }
</script>